import { ReactElement, useEffect, useState } from 'react';
import { convertTimeTo12HourFormat } from '@helper/utils';
import { IQrModal } from '@components/dashboard/components/meeting/index';
import QRCode from 'react-qr-code';
import { ANNUAL_MEETS_GROUP_B, BIG_MEETS } from '@config/constant';
export const QrModal = (props: IQrModal): ReactElement => {
	const { meetingData, modalClose, qrId, isCloseVisible = true } = props;

	const isBigMeetingType = (meetingType: string): boolean => {
		if (!meetingType) return false;
		const type = meetingType.toLowerCase();
		return BIG_MEETS.includes(type);
	};

	const isAnnualMeetGroupB = (meetingType: string): boolean => {
		const annualMeetGroupB = meetingType;
		return ANNUAL_MEETS_GROUP_B.includes(annualMeetGroupB);
	};

	const [qrValue, setQrValue] = useState<string>(() => {
		if (!meetingData?.sfid) return '';
		const endDate = new Date(meetingData?.enddate);
		endDate.setHours(23, 59, 59);
		const endTimestampInSeconds = Math.floor(endDate.getTime() / 1000);

		return isBigMeetingType(meetingData?.meeting_type_c) || isAnnualMeetGroupB(meetingData?.meeting_type_c ?? '')
			? `${meetingData?.sfid}_${endTimestampInSeconds}`
			: `${meetingData.sfid ?? qrId}_${Math.floor(Date.now() / 1000)}`;
	});

	useEffect(() => {
		if (
			meetingData?.meeting_type_c &&
			(isBigMeetingType(meetingData.meeting_type_c) || isAnnualMeetGroupB(meetingData?.meeting_type_c))
		) {
			const endDate = new Date(meetingData?.enddate);
			endDate.setHours(23, 59, 59);
			const endTimestampInSeconds = Math.floor(endDate.getTime() / 1000);
			setQrValue(`${meetingData?.sfid}_${endTimestampInSeconds}`);
			return;
		}

		if (!isBigMeetingType(meetingData?.meeting_type_c ?? '')) {
			const getUtcTimestamp = (): number => Math.floor(Date.now() / 1000);

			setQrValue(`${meetingData?.sfid ?? qrId}_${getUtcTimestamp()}`);

			const interval = setInterval(() => {
				setQrValue(`${meetingData?.sfid ?? qrId}_${getUtcTimestamp()}`);
			}, 5000);

			return (): void => clearInterval(interval);
		}
	}, [meetingData?.sfid, qrId, meetingData?.meeting_type_c, meetingData?.enddate]);

	return (
		<div className="qr-code-wrapper">
			{(meetingData?.sfid || qrId) && <QRCode value={qrValue} size={200} style={{ height: '200px' }} />}

			{meetingData && <p className="h3">{meetingData?.name}</p>}

			{meetingData && (
				<span className="date">
					{meetingData?.status && `${meetingData?.status}, `}
					{convertTimeTo12HourFormat(meetingData?.start_time_c)}
				</span>
			)}

			{isCloseVisible && (
				<button className="close" onClick={modalClose}>
					Close
				</button>
			)}
		</div>
	);
};
